import { Advanced as AdvancedComponent } from './Advanced.component';
import { connector } from './Advanced.connector';

export const Advanced = connector(AdvancedComponent);
